import React, { useEffect, useState } from "react";

import TextLoop from "react-text-loop";
import SpaceParticles from "../../../utils/SpaceParticles";
import Custombutton from "../../../utils/Custombutton";
import Header from "../../layouts/Header/Header";

const Hero = () => {


  return (
    <div className="hero heros">
      <div class="night particle-night">
        <SpaceParticles />

      </div>
      <div className="content px-3 py-3 px-xxl-4 py-xxl-4">

        <Header />
        <div className="  mt-5">
          <h1>
            COSMIC <br />
            <span className="gradient-text">Network</span> <br />
          </h1>
          <TextLoop mask={true}>
            <span className={`bordered-text  `}>Accessible.</span>
            <span className={`bordered-text  `}>Affordable.</span>
            <span className={`bordered-text  `}>Decentralized.</span>
          </TextLoop>
        </div>
        <div className="d-flex buttons align-items-center gap-3 gap-xxl-3  mt-4">
          <Custombutton href={"/#/nebula-lite"} label={"GET NEBULA LITE"} className={"btn-white"} />
          <Custombutton href={"https://app.uniswap.org/swap?outputCurrency=0x55A05Cf8898dd1c582eef939Df645d5D235C6f74&chain=ethereumhttps://app.uniswap.org/swap?outputCurrency=0x55A05Cf8898dd1c582eef939Df645d5D235C6f74&chain=ethereum"} label={"GET $COSMIC"} className={"btn-outline"} />
          <Custombutton href={"https://staking.cosmicnetwork.io/"} label={"Stake $COSMIC"} className={"btn-outline"} />
        </div>
      </div>
    </div>
  );
};

export default Hero;
